import React, { useState } from 'react';
import './css/fleetPlanningDashboard.css'; // We'll create this CSS file next
import { ProSidebar } from "../../components/general/ProSidebar";
import { Link } from 'react-router-dom'; // Import Link if you're using react-router
import "../../App.css";

const FleetPlanningDashboard = () => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div className="container-flex-row">
      <ProSidebar collapsed={collapsed} toggleCollapse={toggleCollapse} />
      <div className="container-flex-row sidebar-adjustment fleet-planning-dashboard-container">
        <div className="dashboard-card-container">
          <div className="dashboard-card instructions-card">
            {/* You could add a logo here */}
            {/* <img src="/logo.png" alt="AmpTrans Logo" className="welcome-logo" /> */}
            <h1>Welcome to AmpTrans!</h1>
            <p>
              We're excited to offer users a free trial of our fleet electrification planning platform.
              Our tool helps you assess the feasibility and economics of transitioning your fleet. Whether to keep all diesel vehicles or switch to a partial or fully electric fleet—whichever offers
              the greatest economic benefits. Using our platform is simple:
            </p>
            <ol>
              <li>1. Start by visiting the <strong>Inputs</strong> page on the left and fill out your fleet's operational needs.</li>
              <li>2. After entering your inputs, you'll be prompted to run the optimization for your fleet. Our advanced <strong>spatial-temporal optimization model</strong> will handle everything, from financial insights to operational schedules.</li>
              <li>3. Check the <strong>Analytics</strong> page for detailed optimization results to help you make an informed decision about your transition.</li>
            </ol>

            <p>
              Our platform is continuously improving. If you have any questions or feedback, feel free to reach out to us at{' '}
              <a href="mailto:info@amptrans.net">info@amptrans.net</a>, and stay tuned for upcoming updates.
            </p>
            
            {/* Added a call-to-action button */}
            <Link to="/inputs">
              <button className="action-button">Get Started Now</button>
            </Link>
          </div>
        </div>
        {/* <div className="dashboard-card-container">
          <div className="dashboard-card">
            <div className="construction-icon">🚧</div>
            <h1 className="dashboard-title">Dashboard</h1>
            <h3 className="dashboard-subtitle">Under Construction</h3>
            <p className="dashboard-message">
              We're working on building an amazing dashboard experience for you.
              Please check back soon!
            </p>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default FleetPlanningDashboard;
